/* src/app/shared/components/ag-drop-down/ag-drop-down.component.scss */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.search-box-wrapper {
  margin-top: 4px;
  position: absolute;
  width: 100%;
}
.activeSearchBox {
  box-shadow: 2px 2px 10px rgba(51, 51, 51, 0.2);
  background-color: #ffffff !important;
  border: 1px solid #dfdfdf;
}
.additional-charges-form {
  background-color: #f2f2f2;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  color: #222222;
  cursor: pointer;
  border: 1.25px solid transparent;
  padding: 0px 16px;
}
.additional-charges-form.ag-size-small {
  height: 48px;
}
.additional-charges-form.ag-size-large {
  height: 56px;
}
.additional-charges-form:hover {
  border: 1.25px solid #dfdfdf;
}
.additional-charges-clickable {
  cursor: pointer;
}
.additional-charges-disabled {
  opacity: 50%;
}
.additional-charges-disabled:hover {
  cursor: default !important;
  border: 1.25px solid transparent !important;
}
.additional-charges-div {
  position: relative;
  width: 100%;
}
.additional-charges-img {
  position: absolute;
  left: 52px;
  top: 8px;
}
.spacer {
  padding-bottom: 4px;
}
.dropDownTitle {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
}
.title-container {
  width: 100%;
}
.title-container img {
  width: 20px;
  height: 20px;
}
.drop-down-message {
  width: inherit;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  padding-left: 2px;
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: #222222;
  padding-top: 4px;
}
.drop-down-message .message-icon {
  height: 12px;
  width: 12px;
}
.drop-down-message .error-icon {
  height: 12px;
  width: 12px;
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
.item {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.checkbox-img {
  pointer-events: none;
  height: 20px;
  width: 20px;
  flex-shrink: 0;
}
/*# sourceMappingURL=ag-drop-down.component.css.map */
